import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../services/security/authentication.service';

@Component({
    selector: 'login',
    styleUrls: [
        './login.scss'
    ],
    templateUrl: 'login.html'
})

export class LoginComponent implements OnInit {
    public model: any = {};
    public loading: boolean = false;
    public warning: string = null;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private authenticationService: AuthenticationService) {

    }

    public ngOnInit() {
        this.authenticationService.logout();
    }

    public login() {
        this.loading = true;
        this.authenticationService.login(this.model.twname, this.model.twpass)
            .subscribe(
                () => {
                    this.router.navigate(['audit']);
                },
                error => {
                    this.warning = error;
                    this.loading = false;
                });
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.component.ts